import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import { BoxValidations } from "@boxes/BoxValidations";
import { FlowBox } from "@boxes/FlowBox";
import style from "@styles/pages/flow/boxes/Box.module.scss";
import { memo } from "react";
import ConditionalBaseBox from "../layout/ConditionalBaseBox";
import { ReportFooter } from "../layout/ReportFooter";

export default memo(({ id, data, selected, isConnectable }) => {
  const subline = () => {
    const str = FlowBox.getSublineByType(
      BoxTypes.OrderFrequencyConditional,
      data
    );
    return str ? <div className={style.subline}>{str}</div> : null;
  };

  return (
    <ConditionalBaseBox
      id={id}
      selected={selected}
      valid={BoxValidations.validate(BoxTypes.OrderFrequencyConditional, data)}
      title={BoxTitles.OrderFrequencyConditional}
      isConnectable={isConnectable}
      footer={<ReportFooter id={id} />}
    >
      {subline()}
    </ConditionalBaseBox>
  );
});
